var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_isarray@2.0.1@isarray/index.js
// module id = jC/k
// module chunks = 0